import React from "react";

const Pagination = ({ handlePageChange, currentPage, totalPages }) => {
  return (
    <main className="mt-4 w-full">
      <div className="flex items-center justify-center flex-grow gap-1 md:gap-3">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(1)}
          className={`px-2 md:px-4 py-2 bg-gray-200 rounded-lg ${
            currentPage === 1 && "opacity-40"
          }`}
        >
          {"<<"}
        </button>
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          className={`px-2 md:px-4 py-2 bg-gray-200 rounded-lg ${
            currentPage === 1 && "opacity-40"
          }`}
        >
          {"<"}
        </button>
        <span className="px-2 text-sm md:text-sm">
          Page {currentPage} of {totalPages}
        </span>
        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          className={`px-2 md:px-4 py-2 bg-gray-200 rounded-lg ${
            currentPage === totalPages && "opacity-40"
          }`}
        >
          {">"}
        </button>
        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(totalPages)}
          className={`px-2 md:px-4 py-2 bg-gray-200 rounded-lg ${
            currentPage === totalPages && "opacity-40"
          }`}
        >
          {">>"}
        </button>
      </div>
    </main>
    // <main className="mt-4 flex items-center justify-center gap-3">
    //   <button
    //     onClick={() => handlePageChange(1)}
    //     className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
    //   >
    //     {"<<"}
    //   </button>
    //   <button
    //     onClick={() => handlePageChange(currentPage - 1)}
    //     className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
    //   >
    //     {"<"}
    //   </button>
    //   <span>
    //     Page {currentPage} of {totalPages}
    //   </span>
    //   <button
    //     onClick={() => handlePageChange(currentPage + 1)}
    //     className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
    //   >
    //     {">"}
    //   </button>
    //   <button
    //     onClick={() => handlePageChange(totalPages)}
    //     className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
    //   >
    //     {">>"}
    //   </button>
    // </main>
  );
};

export default Pagination;
